module.exports = __webpack_public_path__ + "img/curated_msg.25fd6c2b.png";